import { makeSelectRoutes, returnAccess } from "@features/auth/authSlice";
import { Fragment, useEffect, useState } from "react";
import { FaAngleDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import menu from "../sidemenuLinks";
import "../styles.css";
import { useSelector } from "react-redux";

const SellerSidemenuFullView = ({ close }) => {
  const routes = useSelector(makeSelectRoutes);

  const singleLevelArray = (menu) => {
    let tempMenus = [];
    for (let index = 0; index < menu.length; index++) {
      const element = menu[index];
      const item = {
        name: element.name,
        value: element.key,
        link: element.link,
        icon: element.icon,
        ind_text: element.ind_text,
        ind_type: element.ind_type,
      };
      if (element.menu && element.menu.length > 0) {
        const tempMenusNew = singleLevelArray(element.menu);
        tempMenus = [...tempMenus, ...tempMenusNew];
      } else {
        tempMenus = [...tempMenus, item];
      }
    }
    const access = returnAccess(routes);
    tempMenus = tempMenus.filter((e) => {
      if (e.link in access) {
        return true;
      } else {
        return false;
      }
    });
    return tempMenus;
  };

  const [menuListing] = useState(() => {
    return singleLevelArray(menu);
  });
  const [initialLoad, setInitialLoad] = useState(true);
  const [openSet, setOpenSet] = useState({});
  const [searchPath, setSearchPath] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [access, setAccess] = useState([]);

  useEffect(() => {
    setAccess(returnAccess(routes));
  }, [routes]);

  const handleSearchTerm = (event) => {
    setSearchTerm(event.target.value);
  };

  const hasAccess = (link) => {
    if (link?.includes("?")) {
      let reqLink = link;
      reqLink = reqLink.split("?");
      return Object.keys(access).includes(reqLink[0]);
    } else {
      return Object.keys(access).includes(link);
    }
  };

  const checkOpenRoute = (menu) => {
    let splitPath = [];
    if (initialLoad && searchPath !== "") {
      if (searchPath.includes(menu.link)) {
        splitPath = menu.key.split(".");
        if (splitPath.length === 2) {
          setOpenSet({ ...openSet, [splitPath[0]]: !openSet[splitPath[0]] });
          setInitialLoad(false);
        } else if (splitPath.length === 3) {
          setOpenSet({
            ...openSet,
            [splitPath[0]]: !openSet[splitPath[0]],
            [`${splitPath[0]}.${splitPath[1]}`]:
              !openSet[`${splitPath[0]}.${splitPath[1]}`],
          });
          setInitialLoad(false);
        }
      }
    }

    if (initialLoad) {
      if (location.pathname.includes(menu.link)) {
        splitPath = menu.key.split(".");
        if (splitPath.length === 2) {
          setOpenSet({ ...openSet, [splitPath[0]]: !openSet[splitPath[0]] });
          setInitialLoad(false);
        } else if (splitPath.length === 3) {
          setOpenSet({
            ...openSet,
            [splitPath[0]]: !openSet[splitPath[0]],
            [`${splitPath[0]}.${splitPath[1]}`]:
              !openSet[`${splitPath[0]}.${splitPath}`],
          });
          setInitialLoad(false);
        }
      }
    }
  };

  const handleSetClick = (key) => {
    setOpenSet({ ...openSet, [key]: !openSet[key] });
    setInitialLoad(false);
  };

  const handleSearchClick = (event) => {
    setSearchTerm("");
    setSearchPath(event.link);
    setInitialLoad(true);
    setTimeout(checkOpenRoute(event), 2000);
  };

  const menuFunction = (e) => {
    let showChildren = false;
    if (e.menu) {
      e.menu.map((each) => {
        if (hasAccess(each.link)) {
          showChildren = true;
        }
      });
    }
    const isVisible = e.menu ? showChildren : hasAccess(e.link);
    if (!isVisible) return null;
    return (
      <div key={e.key}>
        {e.menu ? (
          <>
            <div
              key={e.key}
              className={`py-2 rounded-md cursor-pointer flex items-center justify-between hover:text-primary text-gray-800 hover:bg-gray-100 text-xs pl-${
                e.key.split(".").length * 4
              }`}
              onClick={() => handleSetClick(e.key)}
            >
              <div className='flex items-center'>
                <span className={`text-gray-700 inline-block text-base`}>
                  {e.icon}
                </span>
                <span className={`pl-4 dropdown-title`}>{e.name}</span>
              </div>
              <FaAngleDown
                className={`text-base mr-4 duration-200 ${
                  openSet[e.key] === false || openSet[e.key] == undefined
                    ? "-rotate-90"
                    : ""
                } `}
              />
            </div>
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                openSet[e.key] === false || openSet[e.key] === undefined
                  ? "max-h-0"
                  : "max-h-screen"
              }`}
            >
              {e.menu.map((el) => (
                <div key={`parentmenu-${el.key}`}> {menuFunction(el)}</div>
              ))}
            </div>
          </>
        ) : (
          <div
            selected={location.pathname === e.link}
            className={e.key.split(".").length === 1 ? "" : ""}
            onClick={checkOpenRoute(e)}
          >
            <Link
              to={`${e.link}`}
              className={` text-xs no-underline flex items-center justify-between hover:bg-gray-100 hover:text-primary duration-100 text-gray-700 py-2 pl-${
                e.key.split(".").length * 4
              } ${location.pathname.includes(e.link) ? "active_link" : ""}`}
              onClick={close}
            >
              <div className='flex items-center'>
                <span className={`inline-block text-base`}>{e.icon}</span>
                <span className={`pl-4`}>{e.name}</span>
              </div>
              <span
                className={`rounded px-1 py-0 inline-block ml-2 ${
                  e.ind_type == "alert" ? "bg-orange-500 text-white" : ""
                } ${e.ind_type == "info" ? "bg-blue-500 text-white" : ""}`}
              >
                {e.ind_text}
              </span>
            </Link>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className='px-2 py-3 flex gap-2 items-center '>
        <input
          onChange={handleSearchTerm}
          placeholder='Search Keyword...'
          className='inputbox text-xs w-full'
          value={searchTerm}
          autoComplete='new-password'
        />
      </div>
      {searchTerm === "" ? (
        <>
          {menu.map((e) => (
            <div key={`unfiltered-${e.key}`}>{menuFunction(e)}</div>
          ))}
        </>
      ) : (
        menuListing
          .filter((each) =>
            each.name.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((eachMenu, index) => (
            <Fragment key={`filtered-${index}`}>
              <Link
                to={`${eachMenu.link}`}
                className={`px-4 text-xs no-underline flex items-center justify-between py-2 ${
                  location.pathname.includes(eachMenu.link) ? "active" : ""
                }`}
                key={`filtered-${index}`}
                onClick={() => handleSearchClick(eachMenu)}
              >
                <div className='flex items-center'>
                  <span className='inline-block text-base'>
                    {eachMenu.icon}
                  </span>
                  <span className='pl-4'>{eachMenu.name}</span>
                </div>
                <span
                  className={`rounded px-1 py-0 inline-block ml-2 ${
                    eachMenu.ind_type == "alert"
                      ? "bg-orange-500 text-white"
                      : ""
                  } ${
                    eachMenu.ind_type == "info" ? "bg-blue-500 text-white" : ""
                  }`}
                >
                  {eachMenu.ind_text}
                </span>
              </Link>
            </Fragment>
          ))
      )}
      <span className='fixed left-2 bottom-10 lg:bottom-0 text-xs text-gray-400 bg-white border-t border-white py-2 block w-48'>
        Built by{" "}
        <a href='https://www.wafttech.com' target='_blank'>
          WaftTech
        </a>
      </span>
    </>
  );
};

export default SellerSidemenuFullView;
